import { NavLink } from 'react-router-dom'

import { LogoStore } from '~/components/LogoStore'

import SubpublisherApprovalBadge from '../SubpublisherApprovalBadge'
import ToggleSubpublisher from '../ToggleSubpublisher'

type RowWithApproval = ListCampaignSubpublisherResponse & {
  approval?: SubpublisherApprovalStatus
}

/**
 * Monta o schema da tabela de subpublishers da campanha. As linhas são sempre
 * a lista curada (`rowData.subpublisher_id` = publisher id), com o status de
 * aprovação opcionalmente anexado em `rowData.approval`.
 */
export function buildSchema({
  withToggle,
  withApproval = false,
  awaitingDistribution = false
}: {
  withToggle: boolean
  withApproval?: boolean
  awaitingDistribution?: boolean
}): TableSchema<RowWithApproval> {
  const columns: TableSchema<RowWithApproval> = {}

  if (withToggle) {
    columns.active = {
      render: rowData => <ToggleSubpublisher data={rowData} />
    }
  }

  columns.publisher = {
    title: 'Publisher',
    render: rowData => (
      <NavLink
        to={`/retail-media/campaigns?rmid=${rowData.id}`}
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <LogoStore
          alt={rowData.name}
          linkLogo={rowData.account_logo}
          backgroundLogo={rowData?.account_theme?.header_color}
          size="small"
        />
        <div style={{ lineHeight: 1, marginLeft: '.5rem' }}>
          <strong className="title">{rowData.name}</strong>
        </div>
      </NavLink>
    ),
    className: 'order__details col__infos col__title',
    showTotal: true,
    width: '100%'
  }

  // A coluna de aprovação é decidida a nível de campanha
  // (require_subpublisher_approval); fora desse modo nem renderizamos o <td>.
  if (withApproval) {
    columns.approval = {
      render: rowData => {
        if (rowData.approval) {
          return (
            <SubpublisherApprovalBadge
              status={rowData.approval.campaign_status}
              reason={rowData.approval.reason}
              publisherName={rowData.name}
              publisherLogo={rowData.account_logo}
            />
          )
        }

        if (awaitingDistribution) {
          return (
            <SubpublisherApprovalBadge
              publisherName={rowData.name}
              publisherLogo={rowData.account_logo}
            />
          )
        }

        return null
      }
    }
  }

  return columns
}
